<template>
  <div class="container mx-auto">
    <div
      class="flex flex-col"
    >
      <div class="flex flex-row">
        <h1 class="heading">
          Trainingseinheit erstellen
        </h1>
      </div>
      <form class="flex flex-col  rounded pt-6 pb-8sm:w-full ml-2 mr-2">
        <div class="mb-4">
          <label
            class="form-element-title"
            for="title"
          >
            Einheit
          </label>
          <input
            id="title"
            v-model="title"
            class="appearance-none rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Titel der Trainingseinheit"
          >
        </div>

        <div class="flex flex-wrap mb-2">
          <div class="mr-4">
            <label
              class="block text-grey-darker text-sm font-bold mb-1"
              for="team"
            >
              Team
            </label>
            <select
              id="team"
              v-model="selectedTeam"
              placeholder="Teams"
              class="block appearance-none w-full border-grey-lighter text-grey-darker py-3 px-2 pr-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-grey appearance-none rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
              @change="teamSelected"
            >
              <option
                value=""
                disabled
                selected
              >
                -- Team wählen --
              </option>
              <option
                v-for="team in teams"
                :key="team.teamId"
                :value="team.teamId"
              >
                {{ team.name }}
              </option>
              <option value="create">
                -- Neues Team anlegen --
              </option>
            </select>
          </div>
          <div>
            <label
              class="block text-grey-darker text-sm font-bold mb-1"
              for="picker"
            >
              Datum
            </label>
            <sc-date-pick
              v-model="date"
              :monday-first="true"
              :language="de"
              @input="inDateSelect=true"
            />
          </div>
        </div>
        <div class="mr-4">
          <label class="block text-grey-darker text-sm font-bold mb-1"> Anmerkungen</label>

          <div class="box rounded flex flex-col bg-white mb-4">
            <sc-html-editor v-model="description" />
          </div>
        </div>
      </form>
      <button
        class="save-button mt-4 w-64 hover:bg-primary-700 hover:border-primary-700"
        type="button"
        @click="save()"
      >
        Speichern
      </button>
    </div>
  </div>
</template>

<script>

import apiService from '../api/apiService'

import { de } from 'vuejs-datepicker/dist/locale'
export default {
    name: 'TrainingSessionsCreate',
    data () {
        return {
            de: de,
            isWarmUpActive: false,
            inSelectionMode: false,
            title: null,
            date: null,
            selectedTeam: '',
            teams: [],
            exercises: [],
            description: '',
            ballMasteries: [],
            selectedMasteries: [],
            isMasterySelectionExpanded: false
        }
    },
    computed: {
        // a computed getter
        showSearch: function () {
            return this.inSelectionMode
        }
    },
    async mounted () {
        await this.loadTeams()
        this.ballMasteries = (await apiService.getBallMasteries()).data

        if (this.id) {

        }
    },
    methods: {
        async save () {
            const ex = this.exercises.map(a => a.shortKey)

            var master = []
            if (this.selectedMasteries && this.selectedMasteries.length > 0) {
                master = this.selectedMasteries.map(a => a.id)
            }
            const result = await apiService.createTrainingSession(this.selectedTeam, this.title, this.description, this.date, ex, master)

            const id = result.headers['x-training']
            this.$router.push({ name: 'training.sessions.modify', params: { id } })
        },
        searchForExercise () {
            this.inSelectionMode = true
        },
        selectMastery (mastery) {
            this.selectedMasteries.push(mastery)
            this.isMasterySelectionExpanded = false
        },
        unselect (shortKey) {
            var filtered = this.exercises.filter(function (value, index, arr) {
                return value.shortKey !== shortKey
            })

            this.exercises = filtered
        },
        toggleExercise (item) {
            this.exercises.push(item)
            this.inSelectionMode = false
            console.log(item)
        },
        teamSelected (item) {
            if (this.selectedTeam && this.selectedTeam === 'create') {
                this.selectedTeam = ''
                this.$router.push({ name: 'teams.create' })
            }

            // TODO Set the new youth to the selected youth
        },
        async loadTeams () {
            const teams = await apiService.getMyTeams()

            console.log(teams)
            if (teams && teams.status === 200) {
                this.teams = teams.data

                if (this.teams) {
                    const storedTeam = localStorage.getItem('currentTeam')

                    if (storedTeam) {
                        this.selectedTeam = storedTeam
                    } else if (this.teams.length === 1) {
                        this.selectedTeam = this.teams[0].teamId
                        localStorage.setItem('currentTeam', this.selectedTeam)
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
  /*local*/
</style>

<style>
  .datepicker {

  }

  .vdatetime-input {
    height: 44px;
  }
</style>